<section class="channel-creation-dialog">
  <custom-modal-card>
    <ng-container header>
      <default-modal-header
        [title]="channel() ? 'Modifier le support' : 'Créer un support'"
        [description]="
          channel()
            ? 'Renseigner le champ ci-dessous pour la modification du support'
            : 'Renseigner le champ ci-dessous pour la création du support'
        "
      ></default-modal-header>
    </ng-container>
    <ng-container body>
      <channel-creation-form [channel]="channel()" />
    </ng-container>
  </custom-modal-card>
</section>
